import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { ThemeService } from '../../shared/theme/services/theme.service';

@Injectable({
  providedIn: 'root',
})
export class CustomThemeResolver implements Resolve<any> {

  private renderer: Renderer2;

  /**
   * Constructor
   *
   * @param document
   * @param rendererFactory
   * @param meta
   * @param themeService
   */
  public constructor(
    @Inject(DOCUMENT) private document,
    private rendererFactory: RendererFactory2,
    private meta: Meta,
    private themeService: ThemeService,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * Resolve
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @return {Observable<boolean> | Promise<boolean> | any}
   */
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const metaTagCustomTheme: HTMLMetaElement = this.meta.getTag('name=custom-theme');
    if (metaTagCustomTheme) {
      !!route.data.customTheme
        ? this.themeService.customThemeChangeSubject.next(this.themeService.customTheme)
        : this.themeService.customThemeChangeSubject.next(undefined);
    }

  }
}
